import { useQuery } from '@tanstack/react-query'
import { fetchActiveCandidatesByParty, candidateKeys } from '@/services/candidates'

export function useCandidatesByParty(partyId: string | undefined) {
  const candidatesQuery = useQuery({
    queryKey: candidateKeys.activeByParty(partyId!),
    queryFn: () => fetchActiveCandidatesByParty(partyId!),
    enabled: !!partyId,
  })

  return {
    candidates: candidatesQuery.data,
    isLoading: candidatesQuery.isLoading,
    error: candidatesQuery.error,
  }
}
